import { parsePendingWaste, type PendingWasteCapture } from './wasteCapture';

// F1 · la captura en duda sobrevive a salir de «Mermas» y a recargar (sessionStorage de la pestaña,
// una por usuario). Si el navegador no deja guardar (modo privado, almacenamiento bloqueado), sigue
// en memoria mientras la pantalla viva: nunca rompe la captura.
const keyFor = (userId: string) => `n360.waste.pending.${userId}`;

export function readPendingWaste(userId: string | undefined): PendingWasteCapture | null {
  if (!userId) return null;
  try {
    return parsePendingWaste(window.sessionStorage.getItem(keyFor(userId)));
  } catch {
    return null;
  }
}

export function writePendingWaste(userId: string | undefined, pending: PendingWasteCapture | null): void {
  if (!userId) return;
  try {
    if (pending) window.sessionStorage.setItem(keyFor(userId), JSON.stringify(pending));
    else window.sessionStorage.removeItem(keyFor(userId));
  } catch {
    /* sin almacenamiento: la captura en duda queda solo en memoria */
  }
}
